/* eslint-disable no-dupe-keys */
export default {
  temperature_timer_execution: {
    // 属性（一般与对象内容匹配）
    prop: {
      created_at: '检测时间',
      city_id: '城市',
      max_temperature: '最高温度',
      effective_date: '生效时间',
      valid_billing_rule: '生效费率'
    },
    btn: {
      execute_temperature_timer: '立即检测并应用费率'
    },
    status: {
      low_temperature: '原费率',
      high_temperature: '高温费率'
    }
  }
}
